// Project cycles use the same submitted maintenance forms, but their result is
// work completed / no access, rather than the health of the inspected equipment.
export const isProjectMaintenanceCycle = (cycle = {}) =>
  String(cycle.cycle || cycle.cycleName || cycle.name || '').trim().toLowerCase() === 'project';

const photoUrls = (value) => {
  const items = Array.isArray(value) ? value : [value];
  return [...new Set(items.map(item => typeof item === 'string' ? item.trim() : item?.url)
    .filter(url => typeof url === 'string' && /^https?:\/\//i.test(url)))];
};

export function getProjectPhotos(row = {}) {
  const raw = row.rawData || row;
  // Missed submissions store evidence of blocked access separately from the
  // normal before photo. The table API also normalizes those images to photos.
  const noAccessPhotos = getProjectStatus(row) === 'No Access'
    ? [...photoUrls(raw.photo_of_block_reason), ...photoUrls(row.photos)]
    : [];
  return {
    before: [...new Set([...photoUrls(raw.before_picture_of_fan_coil), ...noAccessPhotos])],
    after: photoUrls(raw.additional_photos_of_the_unit),
  };
}

export function getProjectNoAccessReason(row = {}) {
  const raw = row.rawData || row;
  const reason = row.reasonMissed || raw.reason_missed || raw.reason_missed_unit || raw.reason_missed_units;
  return typeof reason === 'string' ? reason.trim() : '';
}

export function getProjectNotes(row = {}) {
  const raw = row.rawData || row;
  const notes = Array.isArray(raw.any_additional_notes) ? raw.any_additional_notes : [raw.any_additional_notes];
  const reason = getProjectStatus(row) === 'No Access' ? getProjectNoAccessReason(row) : '';
  // row.notes can contain an automated HVAC summary or "System Fully
  // Functional". Projects should show the technician's own work notes.
  return [...new Set([reason, ...notes]
    .filter(note => typeof note === 'string' && note.trim())
    .map(note => note.trim()))].join('\n');
}

export function getProjectStatus(row = {}) {
  const raw = row.rawData || row;
  // A completed revisit takes precedence over an older missed reason.
  if (raw.entry_completed === true) return 'Completed';
  if (row.inspection === 'Missed' || getProjectNoAccessReason(row) ||
      (Array.isArray(raw.equipment_missed) && raw.equipment_missed.length > 0)) return 'No Access';
  // Never present an unfinished or unknown record as completed work. The API
  // normally excludes unfinished entries before returning the table data.
  return 'Pending';
}

export function getProjectSummary(rows = []) {
  return rows.reduce((summary, row) => {
    summary[getProjectStatus(row)] += 1;
    summary.total += 1;
    return summary;
  }, { total: 0, Completed: 0, 'No Access': 0, Pending: 0 });
}
